export const WecAiSchedulersFeatureName = 'WecAiSchedulers'
export const CourierExchangeManualAcceptFeatureName = 'CourierExchangeManualAccept'
export const WecAiBookingNotAcceptedSchedulerFeatureName = 'WecAiBookingNotAcceptedScheduler'
export const WecAiMissingPocPodSchedulerFeatureName = 'WecAiMissingPocPodScheduler'
export const WecAiCollectionDeliveryDelaySchedulerFeatureName = 'WecAiCollectionDeliveryDelayScheduler'
export const WecAiDriverOnboardingSchedulerFeatureName = 'WecAiDriverOnboardingScheduler'
export const WecAiETAProviderSchedulerFeatureName = 'WecAiETAProviderScheduler'